export default __webpack_public_path__ + "static/media/gallery8.1551430d.jpg";